import { Component, OnInit } from '@angular/core';
import { SuperadminService } from 'src/app/services/superadmin/superadmin.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { LookupService } from 'src/app/services/Common/lookup.service';
import * as moment from 'moment';

@Component({
  selector: 'app-branch',
  templateUrl: './branch.component.html',
  styleUrls: ['./branch.component.css']
})
export class BranchComponent implements OnInit {


  Submitted: boolean = false;
  UserIDMsg:any;
  BranchList: any;
  School:any;
  Country: any;
  State: any;
  City: any;
  CurrencyList:any;
  SelectedFileForUpload: any;
  Count:number=0;
  SchoolBrachResetList:any;

  constructor(private superadminservice: SuperadminService, private lookupservice: LookupService, 
    public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) { }

    SearchModel={
      FromDate:'',
      ToDate:'',
      PartnerID:0,
      CountryID:0,
      SchoolID:0,
    }
  
    ClearSearch(){
      this.SearchModel.FromDate='';
      this.SearchModel.ToDate='';
      this.SearchModel.PartnerID=0;
      this.SearchModel.CountryID=0; 
      this.SearchModel.SchoolID=0;
      this.BranchList=[];
    }
    BindBranch() {
      this.spinnerService.show();
      this.SearchModel.FromDate =this.SearchModel.FromDate!=null && this.SearchModel.FromDate!=''?moment(this.SearchModel.FromDate).format('DD-MMM-YYYY'):'';
      this.SearchModel.ToDate =this.SearchModel.ToDate!=null && this.SearchModel.ToDate!=''?moment(this.SearchModel.ToDate).format('DD-MMM-YYYY'):'';
     
      this.superadminservice.BindBranch(JSON.stringify(this.SearchModel)).subscribe((response: any) => {
        this.BranchList = response.BranchList;
        this.spinnerService.hide();
  
      });
    };
  
  BranchModel = {
    LogoPath: '',
            BranchID: 0,
            SchoolID: 0,
            BranchName: '',
            JosaBranchCode:'',
            BranchCode: '',
            OwnerName: '',
            Phone: '',
            AffiliationFrom: '',
            ContactNo: '',
            ContactPerson: '',
            IsActive: true,
            AffiliationNo: '',
            CityID: 0,
            StateID: 0,
            CountryID: 0,
            ZipCode: '',
            Address: '',
            StaffName: '',
            UserID: '',
            Password: '',
            CurrencyID: 0,
            DecimalPlace: 0,
            IsPG: false,
            IsGRDisplay:true,
            GRType: "AUTO",
            IsSubBranch:false,
            POBox:'',
            Email:'',
            Fax:''
  };

  Clear() {
    this.BranchModel.LogoPath = '';
    this.BranchModel.BranchID = 0;
    this.BranchModel.BranchName = '';
    this.BranchModel.BranchCode = '';
    this.BranchModel.JosaBranchCode = '';
    this.BranchModel.POBox = '';
    this.BranchModel.OwnerName = '';
    this.BranchModel.Phone = '';
    this.BranchModel.AffiliationFrom = '';
    this.BranchModel.ContactNo = '';
    this.BranchModel.ContactPerson = '';
    this.BranchModel.IsActive = false;
    this.BranchModel.AffiliationNo = '';
    this.BranchModel.CityID = 0;
    this.BranchModel.CountryID = 0;
    this.BranchModel.StateID = 0;
    this.BranchModel.ZipCode = '';
    this.BranchModel.Address = '';
    this.BranchModel.Email = '';
    this.BranchModel.Fax = '';
    this.Submitted = false;
    this.BranchModel.StaffName = '';
    this.BranchModel.UserID = '';
    this.BranchModel.Password = '';
    this.BranchModel.CurrencyID = 0;
    this.BranchModel.DecimalPlace = 0; 
    this.BranchModel.IsPG = false;
    this.BranchModel.IsGRDisplay = true;
    this.UserIDMsg = '';
    this.BranchModel.GRType = "AUTO";
    this.BranchModel.IsSubBranch = false;
    
  };


  
  BranchMarkActive(obj) {
    this.Clear();
    this.BranchModel.BranchID = obj.BranchID;
    this.BranchModel.IsActive = obj.IsActive == true ? false : true;
    this.spinnerService.show();
    this.superadminservice.BranchMarkActive(JSON.stringify(this.BranchModel)).subscribe((response: any) => {
      this.spinnerService.hide();
      this.BindBranch();
      this.globalHelper.CheckActionStatus(response);

    });
  }

  validationDropDown() {
    return this.BranchModel.SchoolID == 0 ||this.BranchModel.CurrencyID == 0|| this.BranchModel.CountryID == 0 ||this.BranchModel.StateID == 0|| this.BranchModel.CityID == 0;
  }

  selectFileforUpload(file) {
    this.SelectedFileForUpload = file[0];
  };


  SaveBranch(valid) {

    this.Submitted = true;
    if (valid && !this.validationDropDown()) {
      this.spinnerService.show();
      this.superadminservice.SaveBranch(JSON.stringify(this.BranchModel), (this.SelectedFileForUpload)).subscribe((response: any) => {
        this.spinnerService.hide();
        if (response.UserIDExist == 1) {
          this.UserIDMsg = 'Login ID Already Exist';
      }

      if (response.webResponse.Status && this.BranchModel.BranchID==0) {
          this.Clear();

      }
      if (response.webResponse.Status) {
          this.BindBranch();         
      }
     
        this.globalHelper.CheckActionStatus(response)
      });
    }
  };


  Edit(obj) {
   this.BranchModel.SchoolID = obj.SchoolID;
   this.BranchModel.BranchID = obj.BranchID;
   this.BranchModel.BranchName = obj.BranchName;
   this.BranchModel.POBox = obj.POBox;
   this.BranchModel.BranchCode = obj.BranchCode;
   this.BranchModel.JosaBranchCode = obj.JosaBranchCode;
   this.BranchModel.OwnerName = obj.OwnerName;
   this.BranchModel.AffiliationFrom = obj.AffiliationFrom;
   this.BranchModel.ContactNo = obj.ContactNo;
   this.BranchModel.ContactPerson = obj.ContactPerson;
   this.BranchModel.IsActive = obj.IsActive;
   this.BranchModel.AffiliationNo = obj.AffiliationNo;
   this.BranchModel.Phone = obj.Phone;
   this.BranchModel.CountryID = obj.CountryID;
   this.GetBranchState();
   this.BranchModel.StateID = obj.StateID;
   this.GetBranchCity();
   this.BranchModel.CityID = obj.CityID;
   this.BranchModel.ZipCode = obj.ZipCode;
   this.BranchModel.Address = obj.Address;
   this.BranchModel.Fax = obj.Fax;
   this.BranchModel.Email = obj.Email;
   this.BranchModel.UserID = obj.UserID;
   this.BranchModel.Password = obj.Password;
   this.BranchModel.StaffName = obj.StaffName;
   this.BranchModel.CurrencyID = obj.CurrencyID;
   this.BranchModel.DecimalPlace = obj.DecimalPlace;
   this.BranchModel.IsPG = obj.IsPG;
   this.BranchModel.GRType = obj.GRType;
   this.BranchModel.IsGRDisplay = obj.IsGRDisplay;
   this.BranchModel.IsSubBranch = obj.IsSubBranch;
  
  };

  ngOnInit() {
    this.GetBindCountry();  
    this.GetBranchSchool();
    this.GetCurrency();
    this.GetPartner();
    this.BindBranch();

  }

 
  GetBranchSchool() {
    this.lookupservice.GetLookupsList('School', '').subscribe((data: any) => {
      this.School = data.LookupItems;
    });
  };

  GetBindCountry() {
    this.lookupservice.GetLookupsList('Country', '').subscribe((data: any) => {
      this.Country = data.LookupItems;
    });
  };

  GetCurrency() {
    this.lookupservice.GetLookupsList('Currency', '').subscribe((data: any) => {
      this.CurrencyList = data.LookupItems;
    });
  };
  PartnerList=[];
  GetPartner() {
    this.lookupservice.GetLookupsList('Partner', '').subscribe((data: any) => {
      this.PartnerList = data.LookupItems;
    });
  };

  GetBranchState() {
    var Itembo = {
      'ItemId': this.BranchModel.CountryID
    }
    this.lookupservice.GetLookupsList('State', JSON.stringify(Itembo)).subscribe((data: any) => {
      this.State = data.LookupItems;
    });
  };

 
  GetBranchCity() {
    var Itembo = {
      'ItemId': this.BranchModel.StateID
    }
    this.lookupservice.GetLookupsList('City', JSON.stringify(Itembo)).subscribe((data: any) => {
      this.City = data.LookupItems;
    });
  };


  // Select All

  SelectModel={
    IsAction:false
  }


  ClearSelection () {
      this.SelectModel.IsAction = false;
  }

  SelectAllAction() {

      if (this.SelectModel.IsAction) {
          for (var i = 0; i < this.BranchList.length; i++) {

              this.BranchList[i].IsSelectAction = true;

          }
      }
      if (this.SelectModel.IsAction == false) {
          for (var i = 0; i < this.BranchList.length; i++) {
              this.BranchList[i].IsSelectAction = false;

          }
      }

  }

  ChangeActionSelect(item) {
      this.Count = 0;
      for (var i = 0; i < this.BranchList.length; i++) {
          if (this.BranchList[i].IsSelectAction) {
              this.Count = this.Count + 1

          }
      }


      if (this.Count == this.BranchList.length) {
          this.SelectModel.IsAction = true;

      }
      else {
          this.SelectModel.IsAction = false;
      }

  }


  // Reset Password


  ResetSchoolBrachLoginID() {
    this.SchoolBrachResetList = [];
    this.spinnerService.show();
    for (var i = 0; i < this.BranchList.length; i++) {
        if (this.BranchList[i].IsSelectAction == true) {
            var item = {
                UserLoginID: this.BranchList[i].UserLoginID
            }
            this.SchoolBrachResetList.push(item);
        }

    }
    this.superadminservice.ResetSchoolBrachLoginID(JSON.stringify(this.SchoolBrachResetList)).subscribe((data: any) => {
      this.spinnerService.hide();
        if (data.webResponse.Status) {
            this.ClearSelection();
            this.BindBranch();
        }
        this.globalHelper.CheckActionStatus(data)
    });


}


}



